import { Component, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import {
  ShiftTimeAndFlexResponse,
  BaseInquiryShiftsWithFlex,
  ShiftTimeResponse,
  baseInquirySelectors,
  SimilarInquiryMappedInterface,
  BaseCoreState,
  BaseShiftIconsEnum,
} from 'base';

@Component({
  selector: 'base-customer-shift-plan-similar-inquiries',
  templateUrl: './base-customer-shift-plan-similar-inquiries.component.html',
})
export class BaseCustomerShiftPlanSimilarInquiriesComponent implements OnInit, OnDestroy {
  shiftTimes: (ShiftTimeResponse & { index: number; label?: string })[] = [];
  shiftTimesWithFlex: (ShiftTimeAndFlexResponse & { index: number; label?: string })[] = Object.values(
    BaseInquiryShiftsWithFlex
  ).map((type) => ({
    endTime: '',
    startTime: '',
    break: 0,
    type: type,
    label: type,
    index: 0,
  }));
  similarInquiries: SimilarInquiryMappedInterface[] = [];

  baseShiftIconsEnum = BaseShiftIconsEnum;
  inquiryShiftTypes = BaseInquiryShiftsWithFlex;
  private destroy$ = new Subject();

  constructor(private store: Store<BaseCoreState>) {}

  ngOnInit() {
    this.store
      .select(baseInquirySelectors.getSimilarInquiriesMapped)
      .pipe(takeUntil(this.destroy$))
      .subscribe((similarInquiries: SimilarInquiryMappedInterface[]) => {
        this.similarInquiries = similarInquiries;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  trackByInquiry(_: number, item: SimilarInquiryMappedInterface) {
    return item.data.id;
  }
}
